import {uniqueArray} from '@coolcolduk/util';
import {useMemo} from 'react';
import {ModuleTopic} from '@cp/model';
import mapModuleTopicsArrayToRecordModuleTopicsByCategory from './map/mapModuleTopicsArrayToRecordModuleTopicsByCategory';
import mapModuleTopicToTopicId from './map/mapModuleTopicToTopicId';
import mapTopicsToTreeObject from './map/mapTopicsToTreeObject';

/**
 * useTopicSelectionTreeObject is a hook that transforms the module topics into a 2-level tree structure: Category > Topic
 * @param moduleTopics - The module topics to transform
 * @returns The transformed tree object
 */
export default function useTopicSelectionTreeObject(moduleTopics: ModuleTopic[]) {
  const topicsObject = useMemo(() => mapModuleTopicsArrayToRecordModuleTopicsByCategory(moduleTopics), [moduleTopics]);
  const treeObject = useMemo(() => mapTopicsToTreeObject(topicsObject), [topicsObject]);

  // convert module topics to topic strings
  const topicStrings = useMemo(
    () => uniqueArray(moduleTopics.map((moduleTopic) => mapModuleTopicToTopicId(moduleTopic))),
    [moduleTopics],
  );

  const categoryIds = useMemo(() => Object.keys(topicsObject), [topicsObject]);

  const allTopicStrings = useMemo(() => [...topicStrings, ...categoryIds], [topicStrings, categoryIds]);

  return {
    treeObject,
    topicsObject,
    allParentTopicStrings: categoryIds,
    allChildTopicStrings: topicStrings,
    allTopicStrings,
  };
}
